import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// BANK STATEMENT RELATED APIs
// ==============================================

// 1. Get All Bank Details
export const getAllBankDetails = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetAllBankDetails`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Transaction Types
export const getTransactionTypes = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetTrans`,   
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. View Bank Statement Grid
export const viewBankStatementGrid = async (params) => {
    try {
        const { bankVal, fromDate, toDate, tranType } = params;
         // DEBUG
        
        const queryParams = new URLSearchParams({
            BankVal: bankVal || '',
            FromDate: fromDate || '',
            ToDate: toDate || '',
            TranType: tranType || ''
        });
        
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/ViewBankStatementGrid?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Get Bank Transaction Details
export const getBankTranDetails = async (params) => {
    try {
        const { transId, typeId } = params;
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetBankTranDetails?TransId=${transId}&TypeId=${typeId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};